export default __webpack_public_path__ + "static/laila_bapna-10b93ed0123bc43551f3bffe5a8fc7e9.jpg";